"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var transformBlock = function (d) { return new Block(d.data); };
var transformBlocks = function (d) { return d.data.map(function (c) { return new Block(c); }); };
exports.CreateBlockEndpoint = function (opts) {
    var connection = opts.connection;
    return {
        get: function (ref) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, connection.get(ref).then(transformBlock)];
                });
            });
        },
        set: function (obj) {
            return __awaiter(this, void 0, void 0, function () {
                var ref;
                return __generator(this, function (_a) {
                    if (obj.links && obj.links.self) {
                        ref = obj.links.self;
                        return [2 /*return*/, connection.put(ref, { block: obj }).then(transformBlock)];
                    }
                    ref = "/api/v2/projects/" + obj.project_id + "/blocks";
                    return [2 /*return*/, connection.post(ref, { block: obj }).then(transformBlock)];
                });
            });
        },
        setMany: function (obj, project_id) {
            return __awaiter(this, void 0, void 0, function () {
                var ref;
                return __generator(this, function (_a) {
                    ref = "/api/v2/blocks/set";
                    return [2 /*return*/, connection.post(ref, { blocks: { blocks: obj, project_id: project_id } }).then(transformBlocks)];
                });
            });
        },
        del: function (ref) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, connection.delete(ref)];
                });
            });
        },
    };
};
var Block = /** @class */ (function () {
    function Block(props) {
        var data = props.attributes;
        this.id = props.id;
        this.version = props.version;
        this.props = data.props;
        this.type = data.type;
        this.links = props.links;
        this.meta = data.meta;
        this.animator = data.animator;
        this.children = data.children;
        this.project_id = data.project_id;
        this.deletedAt = data.deleted_at;
    }
    return Block;
}());
exports.Block = Block;
